import { addressColumn, primaryRelationshipColumn, roleColumn } from "./columnHelpers";

export const propertiesRelationship = {
    collapsible: true,
    title: 'Properties',
    tint: 'property',
    type: 'table',
    columns: [
        // primaryRelationshipColumn({label: 'Address', endpoint: 'properties', column: 'address' }),
        addressColumn,
        roleColumn,
    ],
};
